module.exports = __webpack_public_path__ + "img/qrcodeNew.5d5c2d28.png";